import { render } from "./RiskAssessmentGuide.vue?vue&type=template&id=368aec11&scoped=true"
import script from "./RiskAssessmentGuide.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentGuide.vue?vue&type=script&lang=js"

import "./detailColumns.css?vue&type=style&index=0&id=368aec11&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368aec11"]])

export default __exports__